import { fromEvent, Observable } from 'rxjs'
import Choices, { Options as ChoicesOptions, Choice, Types, Item } from 'choices.js'
import { map } from 'rxjs/operators'
import { Container } from 'choices.js/public/types/src/scripts/components'

export class Dropdown {

    public readonly choices$: Observable<Choice>
    private choiceElement: Choices

    constructor(
        protected readonly selectElement: HTMLSelectElement,
        protected readonly options?: Partial<ChoicesOptions>,
    ) {
        if (! this.options) {
            this.options = {
                searchEnabled: false,
                callbackOnCreateTemplates: this.defaultTemplate,
                itemSelectText: '',
            }
        }
        this.choiceElement = this.initChoices(selectElement, this.options)
        this.choices$ = fromEvent<CustomEvent<{ choice: Choice }>>(
            this.choiceElement.passedElement.element, 'choice',
        ).pipe(
            map((value) => value.detail.choice),
        )
    }

    protected initChoices(selectElement: HTMLSelectElement, options: Partial<ChoicesOptions>): Choices {
        return new Choices(selectElement, options)
    }

    protected defaultTemplate(template: Types.StrToEl) {
        return {
            item({ classNames }: Container, data: Item) {
                let image: string | null
                try {
                    image = JSON.parse(data.customProperties as unknown as string).image
                } catch (e) {
                    image = null
                }
                const classes = [
                    classNames.item,
                ]
                classes.push(data.highlighted ? classNames.highlightedState : classNames.itemSelectable)
                classes.push(data.placeholder ? classNames.placeholder : '')

                return template(`
                    <div class="${classes.join(' ')}"
                         data-item
                         data-id="${data.id}"
                         data-value="${data.value}"
                         ${data.active ? 'aria-selected="true"' : ''}
                         ${data.disabled ? 'aria-disabled="true"' : ''}>
                         ${image ? `<img src="${image}"
                             alt=""
                             width="48"
                             height="42"
                             style="object-fit: contain; object-position: center; display: inline-block; margin-right: 1rem"
                         >` : ''}
                            ${data.label}
                    </div>
                `)
            },
            choice({ classNames }: Container, data: Item) {

                let image: string | null
                try {
                    image = JSON.parse(data.customProperties as unknown as string).image
                } catch (e) {
                    image = null
                }

                const classes = [
                    classNames.item,
                    classNames.itemChoice,
                ]

                classes.push(data.disabled ? classNames.itemDisabled : classNames.itemSelectable)
                classes.push(data.selected ? 'selected' : '')

                return template(`
                    <div class="${classes.join(' ')}"
                         data-select-text="${this.config.itemSelectText}"
                         data-choice
                         ${data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable'}
                         data-id="${data.id}"
                         data-value="${data.value}"
                         ${data.groupId! > 0 ? 'role="treeitem"' : 'role="option"'}
                    >
                        <div class="content-wrapper">
                            ${image ? `<img src="${image}"
                             alt=""
                             width="48"
                             height="42"
                             style="object-fit: contain; object-position: center; display: inline-block; margin-right: 1rem"
                         >` : ''}
                            ${data.label}
                        </div>
                        ${data.selected ? '<svg class="svg-check-icon" width="16" height="16"> <use xlink:href="#svg-check-icon"></use></svg>' : ''}
                    </div>
                `)
            },
        }
    }

    static create(selectElement: HTMLSelectElement): Dropdown {
        return new Dropdown(selectElement)
    }
}
